var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(!_vm.isDynamic)?_c('span',{staticClass:"flag-icon",class:_vm.flagClass}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }